import React from 'react'
import PropTypes from 'prop-types'
import { isPast, parseISO } from 'date-fns'
import {
  Scroller,
  GroupHeader,
  HeroScroller,
} from '..'

import styles from './styles'

import { API_IMAGE_OBJECT } from '../../utils/types'

const removeExpired = (asset) => {
  if (!asset.expires) return true
  return !isPast(parseISO(asset.expires))
}

const Group = ({
  assets,
  showTitle,
  name,
  large,
  sponsorship,
  specialEvent,
  recoID,
  showCardTitle,
  rowTitle,
  type,
  page,
  isLive,
  liveProgramme,
  groupId,
}) => {
  const live = type === 'live'
  if (!assets.length) return null
  const filteredAssets = assets.filter(removeExpired)
  const poster = (type === 'poster')

  let isSponsorship
  if (sponsorship) {
    const newSponsorship = [sponsorship.image]
    newSponsorship[0]._renditions = {
      '350x269': `${sponsorship.image._filepath.replace('[width]', '350').replace('[height]', '')}`,
    }
    filteredAssets.splice(0, 0, sponsorship)
    isSponsorship = true
  }

  if (!filteredAssets.length) return null
  const classes = ['Group', (sponsorship ? 'sponsorship' : ''), (specialEvent ? 'SpecialEventCard' : ''), (isLive ? 'live' : '')]
    .filter(Boolean)
    .join(' ')

  let groupTitle = rowTitle

  if (specialEvent) {
    groupTitle = filteredAssets[0].title
  }

  return (
    <section className={classes} data-title={groupTitle}>
      {name && <GroupHeader title={name} showTitle={showTitle} specialEvent={specialEvent} />}
      { specialEvent && (
        <HeroScroller
          assets={filteredAssets}
          recoID={recoID}
          liveProgramme={liveProgramme}
        />
      )}
      { !specialEvent && (
        <Scroller
          hasTitle={showTitle}
          isSponsorship={isSponsorship}
          sponsorship={sponsorship}
          specialEvent={specialEvent}
          assets={filteredAssets}
          recoID={recoID}
          live={live}
          groupId={groupId}
          headerName={name}
          showCardTitle={showCardTitle}
          poster={poster}
          page={page}
          large={large}
        />
      )}
      <style jsx>{styles}</style>
    </section>
  )
}

Group.propTypes = {
  name: PropTypes.string,
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      link: PropTypes.string,
      image: API_IMAGE_OBJECT,
      posters: PropTypes.array,
      subtitle: PropTypes.string,
      label: PropTypes.string,
      overlay: PropTypes.string,
    })
  ),
  sponsorship: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    image: PropTypes.shape({
      id: PropTypes.number,
      _filepath: PropTypes.string,
    }),
  }),
  showTitle: PropTypes.bool,
  groupId: PropTypes.number,
  large: PropTypes.bool,
  specialEvent: PropTypes.bool,
  recoID: PropTypes.string,
  showCardTitle: PropTypes.bool,
  rowTitle: PropTypes.string,
  type: PropTypes.string,
  page: PropTypes.string,
  isLive: PropTypes.bool,
  liveProgramme: PropTypes.shape({
    title: PropTypes.string,
    guid: PropTypes.string,
  }),
}

Group.defaultProps = {
  name: '',
  assets: [],
  showTitle: true,
  large: false,
  sponsorship: null,
  specialEvent: false,
  recoID: null,
  groupId: 0,
  showCardTitle: false,
  rowTitle: null,
  type: null,
  page: null,
  isLive: false,
  liveProgramme: {},
}

export default Group
